/* import __COLOCATED_TEMPLATE__ from './group-member.hbs'; */
import Component from "@ember/component";
import { action } from "@ember/object";

export default Component.extend({
  classNames: ["item"],

  @action
  remove(event) {
    event?.preventDefault();
    this.removeAction(this.member);
  },
});
